export default __webpack_public_path__ + "static/media/gr20.7a7912e7.gpx";